<div class="container">
    <!-- Header usando componente shared -->
    <app-page-header
        title="Gestión de Solicitudes de Acceso"
        subtitle="Administra y asigna roles a usuarios pendientes"
        icon="user">
    </app-page-header>

    <div class="form-alert form-alert--error" *ngIf="showAlertError">
        <i class="form-alert-icon">⚠</i>
        <span>{{ errorMessage }}</span>
    </div>
    <div class="form-alert form-alert--success" *ngIf="showAlertSuccess">
        <i class="form-alert-icon">✓</i>
        <span>{{ successMessage }}</span>
    </div>

    <!-- Sección de Solicitudes Pendientes -->
    <section class="pending-requests-section">
        <div class="section-header">
            <div class="header-left">
                <h2 class="section-title">Solicitudes Pendientes</h2>
                <span class="badge-count" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
            </div>
            <div class="header-right">
                <div class="search-box">
                    <input 
                        type="text" 
                        class="search-input" 
                        placeholder="Buscar por email..."
                        [(ngModel)]="searchTerm"
                        (input)="filterRequests()">
                </div>
            </div>
        </div>

        <div class="requests-container" *ngIf="filteredRequests.length > 0">
            <div class="request-card" *ngFor="let request of filteredRequests">
                <div class="request-info">
                    <div class="request-email">
                        <i class="email-icon">✉</i>
                        <span>{{ request.email }}</span>
                    </div>
                    <div class="request-details">
                        <span class="request-date">
                            <i class="date-icon">📅</i>
                            Solicitud: {{ formatDate(request.created_at) }}
                        </span>
                        <span class="request-status" [ngClass]="'status-' + request.status">
                            {{ request.status }}
                        </span>
                    </div>
                </div>
                <div class="request-actions">
                    <div class="role-selector">
                        <label for="role-{{ request.email }}" class="role-label">Rol:</label>
                        <select 
                            id="role-{{ request.email }}" 
                            class="role-select"
                            [(ngModel)]="selectedRole[request.email]"
                            name="role-{{ request.email }}">
                            <option *ngFor="let rol of rols" [value]="rol">{{ rol }}</option>
                        </select>
                    </div>
                    <button 
                        type="button" 
                        class="btn-assign-role"
                        (click)="openAssignRoleModal(request.email)">
                        Asignar Rol
                    </button>
                    <button 
                        type="button" 
                        class="btn-reject-request"
                        (click)="openRejectModal(request.email)">
                        Rechazar
                    </button>
                </div>
            </div>
        </div>

        <div class="empty-state" *ngIf="filteredRequests.length === 0 && searchTerm">
            <i class="empty-icon">🔍</i>
            <p>No se encontraron solicitudes que coincidan con "{{ searchTerm }}"</p>
        </div>

        <div class="empty-state" *ngIf="pendingRequests.length === 0 && !searchTerm">
            <i class="empty-icon">📋</i>
            <p>No hay solicitudes pendientes en este momento</p>
        </div>
    </section>

    <!-- Modal de confirmación para asignar rol -->
    <app-confirmation-modal 
        [isVisible]="isAssignRoleModalVisible" 
        [confirmationText]="'¿Confirmar asignación de rol ' + selectedRole[selectedUserEmail] + ' al usuario ' + selectedUserEmail + '?'"
        [confirmButtonText]="'Confirmar'" 
        (confirmed)="onConfirmAssignRole()"
        (canceled)="onCancelAssignRole()">
    </app-confirmation-modal>

    <!-- Modal de confirmación para rechazar solicitud -->
    <app-confirmation-modal 
        [isVisible]="isRejectModalVisible" 
        [confirmationText]="'¿Estás seguro de que deseas rechazar la solicitud del usuario ' + selectedUserEmail + '? Esta acción no se puede deshacer.'"
        [confirmButtonText]="'Rechazar'" 
        (confirmed)="onConfirmReject()"
        (canceled)="onCancelReject()">
    </app-confirmation-modal>
</div>